module.exports = __webpack_public_path__ + "static/media/doctor.437be7ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/website/features/testimony/doctor.jpg
// module id = 991
// module chunks = 0